<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <!-- APPROVED/DISAPPROVED PROMPT -->

        <vs-tabs :value="activeTab">
          <!-- ALL CUSTOMERS TAB -->

          <vs-tab :label="$t('Customer.Tabs.All')" icon="list_alt" id="all-tab">
            <vs-table
              :sst="true"
              @search="handleSearch"
              @selected="handleSelected"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="businesses"
            >
              <template slot="thead">
                <vs-th sort-key="contactname">{{
                  $t("Customer.Table.FullName")
                }}</vs-th>
                <vs-th sort-key="joindate">{{ $t("Customer.Email") }}</vs-th>
                <vs-th sort-key="phone">{{ $t("Customer.PhoneNumber") }}</vs-th>

                <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].fname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">
                          {{ data[indextr].fname }} {{ data[indextr].lname }}
                        </h5>
                        <span class="text-muted">{{ data[indextr].name }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].email }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].telephone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{
                        data[indextr].telephone
                      }}</span>
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        id="edit-customer-button"
                        radius
                        color="warning"
                        type="border"
                        icon="edit"
                        @click="updateCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                        radius
                        color="danger"
                        type="border"
                        icon="delete"
                        @click="deletePromptMember(data[indextr].id)"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
                <div class="centerx con-exemple-prompt">
                  <vs-prompt
                    @accept="deleteCustomers(selected.id)"
                    color="danger"
                    @cancel="Closed"
                    @close="Closed"
                    :active.sync="activeDeletePrompt"
                  >
                    <div class="con-exemple-prompt">
                      Are you sure to delete
                      {{ selected.name }}
                      account ?
                    </div>
                  </vs-prompt>
                </div>
              </template>
            </vs-table>
            <vs-pagination
              @change="handleChangePage"
              :total="totalPages"
              v-model="currentPage"
            ></vs-pagination>
          </vs-tab>

          <!-- APPROVED CUSTOMERS TAB -->

          <!-- DISAPPROVED CUSTOMERS TAB -->
        </vs-tabs>
      </vs-card>
      <v-tour name="CustomersA" :steps="steps">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step
              v-for="(step, index) of tour.steps"
              v-if="tour.currentStep === index"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template v-if="tour.currentStep === 0">
                <div slot="actions" class="v-step__buttons">
                  <button @click="promptShow" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
              <template v-if="tour.currentStep === 1">
                <div slot="actions" class="v-step__buttons">
                  <button @click="tour.previousStep" class="v-step__button">
                    Previous
                  </button>
                  <button @click="goToNextPage" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>
    </vs-col>
  </vs-row>
</template>

<script>
import { businessService } from "../../_services";
import router from "../../_helpers/router";
import CustomizerSidebar from "../../layout/full/customizer/CustomizerSidebar.vue";
// moment

export default {
  name: "Customers",
  data: () => ({
    idRoute: "",
    title: "Customers",
    activePrompt: false,
    activeDeletePrompt: false,
    activeUpdatePrompt: false,
    activeBookPrompt: false,
    activeUploadPrompt: false,
    activeApprovalPrompt: false,
    businesses: [],
    approvedBusinesses: [],
    disapprovedBusinesses: [],
    selected: {},
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    totalApprovedPages: 0,
    currentApprovedPage: 1,
    totalDisapprovedPages: 0,
    currentDisapprovedPage: 1,
    maxItems: 0,
    importModal: {
      file: null,
    },
    steps: [
      {
        target: "#add-customer-form", // We're using document.querySelector() under the hood
        header: {
          title: "Get Started",
        },
        params: {
          placement: "right-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#edit-customer-button",
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    errors: {
      firstName: false,
      lastName: false,
      email: false,
      phoneNumber: false,
      libID: false,
      selected: {
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false,
        libID: false,
      },
    },
    fname: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    dateOfBirth: "",
    searchKeyword: "",
  }),
  methods: {
    updateCustomer(uid) {
      this.$router.push("/customers/" + this.idRoute + "/update/" + uid);
    },

    deleteCustomers(id) {
      console.log(id);
      console.log("deleted");
      let self = this;
      businessService
        .deleteUser(id)
        .then(function (data) {
          self.$vs.notify({
            title: "succes delete",
            text: "account successfully deleted",
            position: "bottom-right",
            type: "success",
            color: "green",
          });
          router.go();
        })
        .bind(this);

      this.activeDeletePrompt = false;
      this.selected = null;
      // this.$router.push('/settings/team');S
    },
    deletePromptMember(item) {
      this.selected.id = item;
      this.activeDeletePrompt = true;
    },

    handleSelected() {},
    handleSearch() {},
    handleChangePage() {},
  },

  components: {
    CustomizerSidebar,
  },

  created() {
    this.idRoute = this.$route.params.id;

    businessService
      .getUsersByBusinessID(this.$route.params.id)
      .then(
        function (data) {
          console.log("created");
          console.log(data.business_requests.business_id);

          this.businesses = data.business_requests.business_id;
        }.bind(this)
      )
      .finally(() => {
        this.hideLoading();
      });
  },
};
</script>
